module.exports = __webpack_public_path__ + "static/media/Sam_Curry.a0622a77.jpg";